<template>
  <div class="not-found">
    <div class="container fh">
      <div class="content-area">
        <img class="not-found-image" src="@/assets/dashboard_created.svg" />
        <h1 class="fof-text">Console not Configured!</h1>
        <p class="help-text">You need to configure the data first.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.not-found {
  width: 100%;
  height: 100%;
  background: var(--color-secondary);

  .content-area {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .not-found-image {
      width: 200px;
      height: 200px;
      margin: 20px;
    }

    .fof-text {
      font-size: 3rem;
      font-weight: bold;
      opacity: 0.3;
      margin-top: 20px;
    }

    .help-text {
      font-size: 1.2rem;
      padding: 10px 0;
      opacity: 0.7;
    }
  }
}
</style>
